// src/firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; 
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCx4it7zX7XF41K_IrSBTA92FpmOlPPhmE",
  authDomain: "sentinel-safe-prod.firebaseapp.com",
  projectId: "sentinel-safe-prod",
  // --- FIX: Using the correct storageBucket URL format ---
  storageBucket: "sentinel-safe-prod.firebasestorage.app", 
  messagingSenderId: "714504721615",
  appId: "1:714504721615:web:416f3c8c86e2469bf4d3ba",
  measurementId: "G-JDYWVFW8Y4"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

const functions = getFunctions(app, 'europe-west2');

export { 
  db, 
  auth, 
  storage,
  functions,
  app as firebaseApp
};